module.exports = __webpack_public_path__ + "img/button_left_dark.a2c6c25c.png";